import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import {Config} from '../../Config'

export default function ContentId() {
    const roles = new Role();

    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [postDate, setPostDate] = React.useState('');
    let [ownerId, setOwnerId] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [contentCategoryId, setContentCategoryId] = React.useState(null);
    let [sortField, setSortField] = React.useState(null);
    let [sortType, setSortType] = React.useState(null);
    const onSearch = (e) => {
        e.preventDefault();
        getDataSearch({
            postDate : postDate ?? null,
            ownerId : ownerId != null ? ownerId.id : null,
            campaignTypeId : campaignTypeId != null ? campaignTypeId.id : null,
            contentCategoryId : contentCategoryId != null ? contentCategoryId.id : null,
            sortField : e.target.elements.sortField.value,
            sortType : e.target.elements.sortType.value
        });
        setSortField(e.target.elements.sortField.value);
        setSortType(e.target.elements.sortType.value);
    };
    const onSearchReset = () => {
        setPostDate('');
        setOwnerId(null);
        setCampaignTypeId(null);
        setContentCategoryId(null);
        setSortField('id');
        setSortType('DESC');
        setActivePage(0);
        getDataSearch({
            postDate : null,
            ownerId : null,
            campaignTypeId : null,
            contentCategoryId : null,
            sortField: 'id',
            sortType: 'DESC',
            activePage: 1
        });
    };
    const onChangePostDate = (value) => setPostDate(value);
    const onChangeOwnerId = (obj) => setOwnerId(obj);
    const onChangeCampaignTypeId = (obj) => setCampaignTypeId(obj);
    const onChangeContentCategoryId = (obj) => setContentCategoryId(obj);
    const onChangeSortField = (Id) => setSortField(Id);
    const onChangeSortType = (Id) => setSortType(Id);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getDataSearch({
            postDate : postDate ?? null,
            ownerId : ownerId != null ? ownerId.id : null,
            campaignTypeId : campaignTypeId != null ? campaignTypeId.id : null,
            contentCategoryId : contentCategoryId != null ? contentCategoryId.id : null,
            sortField: sortField ?? null,
            sortType: sortType ?? null,
            activePage: pageNum
        });
    };
    //endregion

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [owner, setOwner] = React.useState('');
    let [campaignType, setCampaignType] = React.useState('');
    let [contentCategory, setContentCategory] = React.useState('');

    React.useEffect(() => {
        (async function() {
            try {
                const resOwner = await Utils.getOwner();
                setOwner(resOwner);
                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);
                const resContentCategory = await getContentCategory();
                setContentCategory(resContentCategory);
                const result = await getData({
                    postDate : null,
                    ownerId : null,
                    campaignTypeId : null,
                    contentCategoryId : null,
                    sortField: 'id',
                    sortType: 'DESC'
                });
                setCountAllItem(result.count);
                setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
                setData(result.rows);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getContentCategory() {
        const response = await fetch(Config.url.API_URL +'/api/contentCategory/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getData(params) {
        setLoading(true);
        const response = await Utils.listingByUserId('/api/contentId/listing', {
                postDate: params.postDate ?? null,
                ownerId: params.ownerId ?? null,
                campaignTypeId: params.campaignTypeId ?? null,
                contentCategoryId: params.contentCategoryId ?? null,
                sortField: params.sortField ?? 'id',
                sortType: params.sortType ?? 'DESC',
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
        });

        setLoading(false);
        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const getDataSearch = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        Utils.listingByUserId('/api/contentId/listing', {
                postDate: params.postDate ?? null,
                ownerId: params.ownerId ?? null,
                campaignTypeId: params.campaignTypeId ?? null,
                contentCategoryId: params.contentCategoryId ?? null,
                sortField: params.sortField ?? 'id',
                sortType: params.sortType ?? 'DESC',
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getDataSearch({
            name : null,
            nameEn : null,
            geoId: null,
            sortField: 'id',
            sortType: 'DESC',
            activePage: 1,
            itemPerpage: e.target.value
        });
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> ContentId</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_CONTENT_ID) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/contentId/create'><span><Icon.PlusLg/> เพิ่มข้อมูล</span></NavLink>
                    ) : ''}

                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
                <>
                    <div className="bg-light border rounded my-2">
                        <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                        <div className={showSearch ? 'd-block p-3':'d-none'}>
                            <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="postDate" className="form-label">วันที่โพสต์</label>
                                    <DatePicker
                                        selected={postDate}
                                        onChange={(date) => onChangePostDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="ownerId" className="form-label">Owner</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={owner}
                                        onChange={(event) => onChangeOwnerId(event)}
                                        defaultValue={ownerId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12 col-sm-6 d-none">
                                    <label htmlFor="campaignTypeId" className="form-label">Campaign Type</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={campaignType}
                                        onChange={(event) => onChangeCampaignTypeId(event)}
                                        defaultValue={campaignTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12 col-sm-6 d-none">
                                    <label htmlFor="contentCategoryId" className="form-label">Content Category</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={contentCategory}
                                        onChange={(event) => onChangeContentCategoryId(event)}
                                        defaultValue={contentCategoryId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="sortField" className="form-label">เรียงลำดับ</label>
                                    <div className="row">
                                        <div className="col-8">
                                            <select className="form-select" id="sortField" onChange={(event) => onChangeSortField(event.target.value)} value={sortField ?? ''}>
                                                <option value="id">Id</option>
                                                <option value="postDate">วันที่โพสต์</option>
                                                <option value="ownerId">Owner</option>
                                                <option value="campaignTypeId">Campaign Type</option>
                                                <option value="contentCategoryId">Category Type</option>
                                            </select>
                                        </div>
                                        <div className="col-4">
                                            <select className="form-select" id="sortType" onChange={(event) => onChangeSortType(event.target.value)} value={sortType ?? ''}>
                                                <option value="DESC">DESC</option>
                                            <option value="ASC">ASC</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        <>
                            <div className="table-container shadow">
                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th className="w150">Content ID</th>
                                    <th className="w100 text-center">วันที่โพสต์</th>
                                    <th>Owner</th>
                                    <th>Product Type</th>
                                    <th>Category Type</th>
                                    {roles.isEdit(Utils.MENU_CONTENT_ID) ? (
                                        <th className="w120 text-center">Campaign Status</th>) : ''
                                    }
                                    <th className="w100 text-center">วันที่สร้าง</th>
                                    <th className="w100 text-center">วันที่อัพเดต</th>
                                    <th className="w100 text-center">เครื่องมือ</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.map((row, index) => {
                                return (
                                    <tr key={index} id={"rowId" + row.id}>
                                            <td>{Utils.contentIdGenerater(row)}</td>
                                            <td className="text-center">{row.postDate}</td>
                                            <td>{row.owner ? row.owner.name : ''}</td>
                                            <td>{row.campaignType ? row.campaignType.name : ''}</td>
                                            <td>{row.contentCategory ? row.contentCategory.name : ''}</td>
                                        {roles.isEdit(Utils.MENU_CONTENT_ID) ? (
                                            <td className="text-center">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input float-none" type="checkbox"
                                                           name="statusChecked" id="status" checked={row.status === 1}
                                                           onChange={(e) => Utils.onStatusClick(e, row, data, setData, 'contentId')}/>
                                                    <label className="form-check-label" htmlFor="status">

                                                    </label>
                                                </div>
                                            </td>) : ''
                                        }
                                            <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                            <td className="text-center">{Utils.dateTime(row.updatedAt)}</td>
                                            <td className="text-center">
                                                {roles.isEdit(Utils.MENU_CONTENT_ID) ? (
                                                    <Link className="btn btn-sm btn-light mx-1" to={'/contentId/edit/' + Utils.encodeItem({id: row.id, createdAt: row.createdAt})}><Icon.Pencil/></Link>
                                                ) : ''}
                                                {roles.isDelete(Utils.MENU_CONTENT_ID) ? (
                                                    <button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('contentId', row.id, Utils.contentIdGenerater(row))}><Icon.Trash/></button>
                                                ) : ''}
                                            </td>
                                        </tr>
                                    );
                                })
                                }
                                </tbody>
                            </table>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                    <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <div className="col-12 col-sm-8">
                                    <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination justify-content-sm-end"
                                            activePage={activePage}
                                            itemsCountPerPage={itemPerpage}
                                            totalItemsCount={countAllItem}
                                            pageRangeDisplayed={5}
                                            onChange={(pageNum) => onPageChange(pageNum)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </main>
    );
}